import React from 'react';
import { DeviceClass } from 'shared/models';
import { CameraIcon } from './icons/CameraIcon';
import { DisplayIcon } from './icons/DisplayIcon';
import { RelayIcon } from './icons/RelayIcon';

require('./DeviceClassIcon.css');

export type Props = {
    deviceClass: DeviceClass;
    size: 'small';
};

export const DeviceClassIcon = ({ deviceClass, size }: Props) => {
    switch (deviceClass) {
        case 'camera':
            return <CameraIcon size={ size }/>;
        case 'display':
            return <DisplayIcon size={ size }/>;
        case 'relay':
            return <RelayIcon size={ size }/>;
        default:
            return <div>{ deviceClass }</div>;
    }
};
